import React, { useEffect, useState } from "react";

function FilterOption({ filter,item, onChange, selected }) {

    const [checked, setChecked]= useState(selected)

    const handleCheck = () =>{
      let checkStatus = !checked;

      setChecked(checkStatus);
      if(onChange){
        onChange(item?.id, checkStatus,item?.last)
      }
    }

  return (
  <div
    key={item.id}
    className="rounded-md px-2  mr-1.5 mb-[10px] text-d16"
  >
    <div
      className="flex items-center gap-2 cursor-pointer select-none"
      onClick={handleCheck}
    >
      <input
        type="checkbox"
        id={`filter-${item.id}`}
        checked={checked}
        onChange={() => {}} // Prevents React warning
        className="accent-dblack2 cursor-pointer w-4 h-4"
      />

      {filter.name === "Colore" ? (
        <img
          src={item.image}
          alt={item.name}
          className={`w-8 h-8 rounded-full object-cover transition-all duration-200 ${
            checked ? "border-2 border-dblack2" : "border border-transparent"
          }`}
        />
      ) : (
        <span className="text-xs truncate">{item.name}</span>
      )}
    </div>
  </div>

  );
}

export default FilterOption;
